// eslint-disable-next-line import/order
import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
// eslint-disable-next-line import/order
import type { Command } from '@atlaskit/editor-common/types/command';
import { pluginFactory } from '@atlaskit/editor-common/utils/plugin-state-factory';
import type { EditorState, SafeStateField, Transaction } from '@atlaskit/editor-prosemirror/state';

import { rovoAgentsPluginKey } from './plugin-key';
import { reducer } from './reducer';
// eslint-disable-next-line import/order
import type { RovoAgentAction, RovoAgentsPluginState } from './states';

const dest = pluginFactory(rovoAgentsPluginKey, reducer);
export const createPluginState: (
	dispatch: Dispatch,
	initialState: RovoAgentsPluginState | ((state: EditorState) => RovoAgentsPluginState),
) => SafeStateField<RovoAgentsPluginState> = dest.createPluginState;
export const createCommand: <A = RovoAgentAction>(
	action: A | ((state: Readonly<EditorState>) => false | A),
	transform?: (tr: Transaction, state: EditorState) => Transaction,
) => Command = dest.createCommand;

export const getRovoAgentsPluginState = (state: EditorState): RovoAgentsPluginState | undefined => {
	const pluginState = rovoAgentsPluginKey.getState(state);
	return pluginState;
};
